export default class WSClient {
  constructor(route, withAuth=true) {
    this.ws = {};

    // 0 - CONNECTING
    // 1 - OPEN
    // 2 - CLOSING
    // 3 - CLOSED
    this.state = null;
    this.reconnectTimeout = null;

    this.url = '';
    this.route = route;
    this.withAuth = withAuth;

    this.handlers = {};
    this.requests = {};
  }

  connect() {
    this.url = process.env.VUE_APP_WS_URL + this.route;
    if( this.withAuth ) {
      const token = localStorage.getItem('jwt');
      this.url += '?jwt=' + token;
    }
    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.state = this.ws.readyState;
    };
    this.ws.onclose = () => {
      this.state = this.ws.readyState;
      this.reconnectTimeout = setTimeout(()=>{
        this.connect();
      }, 1000);
    };


    this.ws.onmessage = (event) => {
      const msg = JSON.parse(event.data);

      if (msg.requestId && this.requests[msg.requestId]) {
        this.requests[msg.requestId](msg);
        delete this.requests[msg.requestId];
      }

      if (msg.type && this.handlers[msg.type]) {
        this.handlers[msg.type](msg.data);
      }
    };
  }

  send(message, callback = null) {
    if (callback) {
      message.requestId = Math.random().toString(36).substring(2);
      this.requests[message.requestId] = callback;
    }
    this.ws.send(JSON.stringify(message));
  }

  on(type, callback) {
    this.handlers[type] = callback;
  }
}
